import {FC, useState} from 'react'
import {ProjectIndex} from '@/features/projects/types.ts'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {Button} from '@components/ui/button/Button.tsx'
import {DotsHorizontalIcon, EyeIcon, Trash01Icon} from '@components/ui/icon/Icon.tsx'
import {Menu, MenuGroup, MenuItem} from '@components/ui/menu-atoms/MenuAtoms.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {DeleteProjectModal} from '@/features/projects/components/delete-project-modal/DeleteProjectModal.tsx'
import {Link} from 'react-router-dom'
import {ProjectOptionPrintSiarMenuItem} from '../project-options-dropdown/ProjectOptionPrintSiarMenuItem'
import {ProjectOptionExportSiarMenuItem} from '../project-options-dropdown/ProjectOptionExportSiarMenuItem'
import {ProjectOptionMarkAsTransmittedMenuItem} from '../project-options-dropdown/ProjectOptionMarkAsTransmittedMenuItem'
import {usePermissions} from '@/features/auth/store/store'

export const RowMenu: FC<{project: ProjectIndex; onDeleteSuccess: () => void}> = ({project, onDeleteSuccess}) => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const [isOpen, setOpen] = useState(false)
    const [isDeleteProjectModalOpen, setIsDeleteProjectModalOpen] = useState(false)

    return (
        <>
            <MenuProvider open={isOpen} setOpen={setOpen}>
                <MenuButton
                    render={
                        <Button
                            className={isOpen ? undefined : 'show-on-hover'}
                            size="xs"
                            shape="square"
                            variant="secondary"
                            onClick={event => event.stopPropagation()}
                        >
                            <DotsHorizontalIcon />
                        </Button>
                    }
                />
                <Menu width="220px" onClick={event => event.stopPropagation()}>
                    <MenuGroup>
                        <MenuItem render={<Link to={project.id} />}>
                            <EyeIcon />
                            {t('commons:details')}
                        </MenuItem>
                        {permissions?.projects?.write && (
                            <>
                                <ProjectOptionPrintSiarMenuItem project={project} />
                                <ProjectOptionExportSiarMenuItem project={project} />
                                <ProjectOptionMarkAsTransmittedMenuItem project={project} />
                            </>
                        )}
                    </MenuGroup>
                    {permissions?.projects?.write && (
                        <MenuGroup>
                            <MenuItem
                                variant="danger"
                                disabled={project.status != 'opening' ? true : !project.canDeleteProject}
                                onClick={() => setIsDeleteProjectModalOpen(true)}
                            >
                                <Trash01Icon />
                                {t('commons:delete')}
                            </MenuItem>
                        </MenuGroup>
                    )}
                </Menu>
            </MenuProvider>
            {isDeleteProjectModalOpen && (
                <DeleteProjectModal
                    project={project}
                    onClose={() => setIsDeleteProjectModalOpen(false)}
                    onSuccess={onDeleteSuccess}
                />
            )}
        </>
    )
}
